import { render, staticRenderFns } from "./scrollPane.vue?vue&type=template&id=8a804e14&scoped=true"
import script from "./scrollPane.vue?vue&type=script&lang=js"
export * from "./scrollPane.vue?vue&type=script&lang=js"
import style0 from "./scrollPane.vue?vue&type=style&index=0&id=8a804e14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a804e14",
  null
  
)

export default component.exports